import axios from '@/utils/request'

export default {
  install(Vue) {
    Vue.prototype.homePath = function() {
      if (window.location.href.indexOf('test-rm.ehuzhu.com') >= 0) {
        return 'https://test-rm.ehuzhu.com/app'
      } else if (window.location.href.indexOf('pre-rm.ehuzhu.com') >= 0) {
        return 'https://pre-rm.ehuzhu.com/app'
      } else if (window.location.href.indexOf('localhost:8080') >= 0) {
        return ''
      } else {
        return 'https://rm.ehuzhu.com/app'
      }
    }

    Vue.prototype.axios = axios
    Vue.prototype.toTreeData = function(data, parent, id) {
      const tree = []
      const pos = {}
      for (let i = 0; i < data.length; i++) {
        if (data[i][parent] === 0) {
          data[i].children = []
          tree.push(data[i])
          pos[data[i][id]] = [tree.length - 1]
          data.splice(i, 1)
          i--
        } else {
          const posArr = pos[data[i][parent]]
          if (posArr !== undefined) {
            let obj = tree[posArr[0]]
            for (let j = 1; j < posArr.length; j++) {
              obj = obj.children[posArr[j]]
            }
            data[i].children = []
            obj.children.push(data[i])
            pos[data[i][id]] = posArr.concat([obj.children.length - 1])
            data.splice(i, 1)
            i--
          }
        }
      }
      return tree
    }

    Vue.prototype.filterNull = function(data) {
      const vm = this
      for (var i = 0; i < data.length; i++) {
        if (data[i].children.length < 1) {
          data[i].children = undefined
        } else {
          vm.filterNull(data[i].children)
        }
      }
      return data
    }

    Vue.prototype.checkPermission = function(permCode, permList) {
      for (let i = 0; i < permList.length; i++) {
        if (permList[i] === permCode) {
          return true
        }
      }
    }

    Vue.prototype.distinct = function(a, b) {
      const arr = a.concat(b)
      const result = []
      const obj = {}

      for (const i of arr) {
        if (!obj[i]) {
          result.push(i)
          obj[i] = 1
        }
      }
      return result
    }

    Vue.prototype.unique = function(arr) {
      return Array.from(new Set(arr))
    }

    Vue.prototype.arrSubtraction = function(a, b) {
      if (!a || !b || Object.prototype.toString.call(a) !== '[object Array]' || Object.prototype.toString.call(b) !== '[object Array]') {
        return false
      }
      return a.filter(i => !b.includes(i))
    }
  }
}
